export default "__VITE_ASSET__aJYMpFpeIThoTGTQkecMHw__"